"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDialog = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const AlertDialog = props => {
    const { onOkPress, onCancelPress, children, cancelText, okText, title, disabled, translateFunction = text => text, disableEnforceFocus } = props, moreProps = __rest(props, ["onOkPress", "onCancelPress", "children", "cancelText", "okText", "title", "disabled", "translateFunction", "disableEnforceFocus"]);
    const alertStyles = useAlertStyles();
    return (react_1.default.createElement(core_1.Dialog, { open: true, className: alertStyles.dialogBox, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", disableEnforceFocus: disableEnforceFocus },
        title && react_1.default.createElement(core_1.DialogTitle, null, translateFunction(title)),
        react_1.default.createElement(core_1.DialogContent, { style: { lineHeight: 1.5 } }, children),
        react_1.default.createElement(core_1.DialogActions, null,
            onCancelPress && (react_1.default.createElement(core_1.Button, { focusRipple: false, className: alertStyles.btn, onClick: onCancelPress, color: "primary", autoFocus: true }, translateFunction(cancelText))),
            onOkPress && (react_1.default.createElement(core_1.Button, { className: alertStyles.btn, onClick: onOkPress, color: "primary", disabled: disabled },
                react_1.default.createElement(react_1.default.Fragment, null, translateFunction(okText || 'Ok')))))));
};
exports.AlertDialog = AlertDialog;
const useAlertStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    dialogBox: {
        '& .MuiPaper-root.MuiDialog-paper': {
            minWidth: 500,
            [theme.breakpoints.down('xs')]: {
                minWidth: '80vw',
                maxWidth: '90vw',
            },
        },
    },
    btn: {
        color: theme.palette.info.main,
        letterSpacing: '1.25px',
        fontWeight: 500,
        fontSize: 14,
    },
    text: {
        marginBottom: 4,
    },
}));
//# sourceMappingURL=AlertDialog.js.map